import { useState, createRef } from 'react'
import classNames from 'classnames'

import { faExpand, faPaperclip } from '@fortawesome/free-solid-svg-icons'
import useRenderEvent from '@/core/hooks/useRenderEvent'
import threadsService from '@/app-domains/threads/threads.service'
import sessionService from '@/app-domains/user/session/session.service'

import { ReactComponent as ClipIcon } from '@/assets/icons/clip-icon.svg'
import { ReactComponent as ExpandIcon } from '@/assets/icons/expand-icon.svg'
import { ReactComponent as PaperClipIcon } from '@/assets/icons/paper-clip-icon.svg'
import WritingModalService from '@/app-domains/messages/writing/WritingModal.service'
import DraftManagerService from '@/app-domains/messages/draft/service/DraftManager.service'
import WritingService from '@/app-domains/messages/draft/writing.service'

import './MessageReplyForm.sass'
import store from '@/core/store'

export default function MessageReplyForm (props) {
  const [messageText, setMessageText] = useState('')
  const [isSendingMessage, setIsSendingMessage] = useState(false)
  const [isDraftSetUp, setIsDraftSetUp] = useState(false)
  const [shouldEditOnModal, setShouldEditOnModal] = useState(false)
  const [isDraftCreated, setIsDraftCreated] = useState(false)

  const inputEl = createRef()
  const me = sessionService.getMe().me
  const parentMessageId = props.message.messageid
  const { replyToResponse } = props

  useRenderEvent(['ME:info_updated'])
  useRenderEvent([`DRAFT_MESSAGE_FOR_PARENT:${parentMessageId}:CREATED`], () => {
    setIsDraftCreated(true)
  })

  useRenderEvent([`DRAFT_MESSAGE:${parentMessageId}:SENT`], () => {
    resetState()
  })

  useRenderEvent([`DRAFT_MESSAGE:${parentMessageId}:SHOULD_EDIT_ON_MODAL`], () => {
    setShouldEditOnModal(true)
  })

  /*
    TOFIX: Should we add here an event listener for checking if the text has been updated?
  */

  // Move this function to Thread component ( useContext candidate )

  function setReplyBaseData () {
    let draftData
    if (!isDraftSetUp) {
      draftData = WritingService.setDraftReplyBaseData(props.message, props.thread, me.defaultdomain)
    }
    setIsDraftSetUp(true)
    return draftData
  }

  function openFullReplyModalHandler (options = {}) {
    setReplyBaseData()
    WritingModalService.openReplyToThread(props.message, props.thread, options)
  }

  function openFullReplyModalHandlerWithAttachmentsPrompt () {
    openFullReplyModalHandler()
    setTimeout(() => {
      store.commit('DRAFT_SECTION:OPEN_ATTACHMENT')
    }, 150)
  }

  async function onChange (e) {
    const value = e.target.value

    setMessageText(value)
    if (!isDraftSetUp) {
      setReplyBaseData()
    }
    await WritingService.setMessageText(value)
  }

  function onSubmit (e) {
    e.preventDefault()
  }

  function discardDraft () {
    resetState()
    DraftManagerService.discardReplyDraft(props.message)
  }

  async function sendMessageHandler () {
    setIsSendingMessage(true)
    await threadsService.sendReplyMessage(props.message)
    resetState()
  }

  function resetState () {
    setShouldEditOnModal(false)
    setIsDraftSetUp(false)
    setMessageText('')
    setIsSendingMessage(false)
  }

  return <div className={classNames('response-message-input-container', {
    'border-b': props.borderBottom,
    'border-t': !props.borderBottom,
    'reply-to-response': replyToResponse
  })}>
    {/* <div className="response-photo" onClick={() => inputEl.current?.focus()}>
      <img className="response-photo-img" src={me?.profilePictureUrl || 'https://via.placeholder.com/40'}/>
    </div> */}
    <form className={classNames({
      'not-empty': Boolean(messageText),
      'is-sending_message': isSendingMessage
    })}
        onSubmit={onSubmit}
        onClick={() => inputEl.current?.focus()}
      >

      { !shouldEditOnModal && <textarea
        ref={inputEl}
        className="response-input"
        value={messageText}
        placeholder="Reply"
        onChange={onChange}
        rows={messageText.split('\n').length}
        />
      }

      {shouldEditOnModal && <div className='should-edit-on-modal'>
        <div>
          There's an existing draft for this message pending to be edited in
          <a className='should-edit-on-modal-action ml-xxs' onClick={openFullReplyModalHandler}>
            expanded mode
          </a>
          <br/>
        </div>
        <div>
          <span className='should-edit-on-modal-discard' onClick={discardDraft}>Discard current draft</span>
        </div>
      </div>}
        
      <div className="options">
        <div className="right-content">
          <span className='option-button clip mb-hidden'>
            <ClipIcon icon={faPaperclip} onClick={openFullReplyModalHandlerWithAttachmentsPrompt} />
          </span>
          <span className='option-button expand'>
            <ExpandIcon icon={faExpand} onClick={openFullReplyModalHandler} />
          </span>
          <button className='send-button' type="submit" disabled={!isDraftCreated || isSendingMessage} onClick={sendMessageHandler}>
            <PaperClipIcon />
          </button>
        </div>
      </div>
    </form>
  </div>
}
